import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';
import messages from './ArticleHeader.intl';
import styles from './ArticleHeader.module.scss';

@injectIntl
export default class ArticleHeaderComponent extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    background: PropTypes.object.isRequired
  };

  renderCategories() {
    const { category } = this.props;

    return category && category.length === 1 ? (
      <span className={styles.ArticleHeaderCategoryValueOption}>
        {category[0].name}
      </span>
    ) : (
      category &&
        category.map((taxonomy, index) => {
          return (
            <span
              key={index}
              className={styles.ArticleHeaderCategoryValueOption}
            >
              {taxonomy.name}
            </span>
          );
        })
    );
  }

  render() {
    const {
      className,
      name,
      date,
      background,
      viewWithOnlyArticle
    } = this.props;

    return (
      <div
        className={`${
          background ? styles.ArticleHeader : styles.ArticleHeaderNoBackground
        } ${className}`}
      >
        {background &&
          background.url && (
            <div
              className={styles.ArticleHeaderImage}
              style={{
                backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                  background.url
                )})`
              }}
            />
          )}
        <div
          className={
            background && background.url
              ? styles.ArticleHeaderBox
              : styles.ArticleHeaderBoxNoBackground
          }
        >
          <div className={styles.ArticleHeaderTitle}>
            <span>{name}</span>
          </div>
          <div className={styles.ArticleHeaderDate}>
            {moment(date).format('LL')}
          </div>
          {!viewWithOnlyArticle && (
            <div className={styles.ArticleHeaderCompanyInfo}>
              <span className={styles.ArticleHeaderCategoryLabel}>
                {this.props.intl.formatMessage(messages.category)}
              </span>
              <span className={styles.ArticleHeaderCategoryValue}>
                {this.renderCategories()}
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/Article/ArticleHeader/ArticleHeader.js